import {Injectable} from '@angular/core';
import {SaleInvoiceModel} from '../../../api/entity/saleInvoice.model';
import {SaleInvoiceConverter} from '../../../api/entity/converter/saleInvoice.converter';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {SaleInvoiceDataService} from './saleInvoiceData.service';

@Injectable({ providedIn: 'root' })
export class SaleInvoiceDataServiceAdapter extends
    AbstractDataServiceDtoAdapter<SaleInvoiceModel, SaleInvoiceConverter> {
    constructor(dataService: SaleInvoiceDataService, converter: SaleInvoiceConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): SaleInvoiceModel {
        return new SaleInvoiceModel();
    }
}
